export const Settings = () => {
  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-2xl font-bold mb-4">Settings</h2>
      <div className="bg-white p-4 shadow rounded-lg mb-6">
        {/* User Management */}
        <h3 className="text-lg font-bold mb-2">User Management</h3>
        <table className="table-auto w-full text-left">
          <thead>
            <tr>
              <th className="px-4 py-2">Username</th>
              <th className="px-4 py-2">Role</th>
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">admin</td>
              <td className="border px-4 py-2">Administrator</td>
              <td className="border px-4 py-2">
                <button className="text-blue-500 hover:underline">Edit</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="bg-white p-4 shadow rounded-lg">
        {/* Company Profile */}
        <h3 className="text-lg font-bold mb-2">Company Profile</h3>
        <p className="text-gray-600">
          [Editable company profile form or placeholder]
        </p>
      </div>
    </div>
  );
};

export default Settings;
